import React from "react";
import filterInfo1 from "../assets/images/filter/filter_info1.png";
import filterInfo2 from "../assets/images/filter/filter_info2.png";
import filterInfo3 from "../assets/images/filter/filter_info3.png";
import filterInfo4 from "../assets/images/filter/filter_info4.png";

function Filter() {
  return (
    <section id="filter" className="section-padding bg-white">
      <div className="container mx-auto px-2 sm:px-6">
        <header className="max-w-3xl mx-auto text-center mb-20 px-4 sm:px-0">
          <h2 className="text-sm font-bold text-blue-600 uppercase tracking-[0.3em] mb-4">
            Filtration Systems
          </h2>
          <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 tracking-tight">
            고효율 여과 시스템
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed font-light">
            최대의 에너지 흐름과 효율성을 자랑하는 전문 여과 시스템입니다. <br className="hidden md:block" />
            수영장, 연못, 실험실 등 다양한 환경에서 깨끗한 수질을 유지합니다.
          </p>
        </header>

        {/* Technical Overview */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-32 px-4 sm:px-0">
          <div className="relative group">
            <div className="absolute -inset-4 bg-blue-600/5 rounded-[2rem] scale-95 opacity-0 group-hover:opacity-100 group-hover:scale-100 transition-all duration-500" />
            <img src={filterInfo1} alt="여과기 정보" className="relative w-full rounded-2xl premium-shadow" />
          </div>
          <div className="space-y-8">
            <h3 className="text-3xl font-bold text-slate-900 leading-tight">전문적인 제원 및 사양</h3>
            <p className="text-slate-600 font-light">
              정밀한 설계와 높은 내구성을 바탕으로 설계된 워터피아의 여과기는 장기간 안정적인 성능을
              보장합니다.
            </p>

            <div className="overflow-hidden rounded-2xl border border-slate-100 premium-shadow bg-white">
              <table className="w-full text-left text-sm">
                <thead>
                  <tr className="bg-slate-50 border-b border-slate-100">
                    <th className="px-6 py-4 font-bold text-slate-900">Model Number</th>
                    <th className="px-6 py-4 font-bold text-slate-900 text-center">A</th>
                    <th className="px-6 py-4 font-bold text-slate-900 text-center">B</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  <tr>
                    <td className="px-6 py-4 text-slate-600">72028 / 72229 / 72042 / 72242</td>
                    <td className="px-6 py-4 text-center font-bold text-blue-600">930(37.4")</td>
                    <td className="px-6 py-4 text-center text-slate-600">500(19")</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 text-slate-600">72029 / 72230 / 72043 / 72243</td>
                    <td className="px-6 py-4 text-center font-bold text-blue-600">1130(45.5")</td>
                    <td className="px-6 py-4 text-center text-slate-600">600(24")</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Pump & Filter Specs */}
        <div className="mb-32">
          <div className="max-w-5xl mx-auto overflow-hidden rounded-3xl border border-slate-100 premium-shadow bg-white">
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="bg-slate-900 text-white">
                  <th className="px-8 py-5 font-medium uppercase tracking-wider">Model No.</th>
                  <th className="px-8 py-5 font-medium uppercase tracking-wider">Voltage/Hz</th>
                  <th className="px-8 py-5 font-medium uppercase tracking-wider">Configuration</th>
                  <th className="px-8 py-5 font-medium uppercase tracking-wider">Cert.</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                <tr className="hover:bg-slate-50 transition-colors">
                  <td className="px-8 py-5 font-bold text-slate-900">72028</td>
                  <td className="px-8 py-5 text-slate-500">230/50</td>
                  <td className="px-8 py-5 text-blue-600 font-medium">19" Filter with 0.75HP</td>
                  <td className="px-8 py-5 text-slate-400">CE SAA</td>
                </tr>
                <tr className="hover:bg-slate-50 transition-colors">
                  <td className="px-8 py-5 font-bold text-slate-900">72029</td>
                  <td className="px-8 py-5 text-slate-500">230/50</td>
                  <td className="px-8 py-5 text-blue-600 font-medium">24" Filter with 1.0HP</td>
                  <td className="px-8 py-5 text-slate-400">CE SAA</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Detail Visuals */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-32">
          {[filterInfo2, filterInfo3].map((img, i) => (
            <div
              key={i}
              className="rounded-3xl overflow-hidden bg-slate-50 p-4 border border-slate-100 premium-shadow transition-transform hover:-translate-y-1"
            >
              <img src={img} alt={`상세 정보 ${i + 1}`} className="w-full rounded-2xl" />
            </div>
          ))}
        </div>

        {/* Media & Material Specs */}
        <div className="bg-slate-50 rounded-[1.5rem] md:rounded-[3rem] px-3 py-8 md:p-16 border border-slate-100">
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-12 text-center text-blue-600 uppercase tracking-widest">
            여과재 및 품질 기준
          </h3>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 overflow-hidden rounded-2xl border border-slate-200 bg-white">
              <table className="w-full text-sm text-left">
                <thead>
                  <tr className="bg-slate-100 border-b border-slate-200">
                    <th className="px-6 py-4 font-bold text-slate-900">종류</th>
                    <th className="px-6 py-4 font-bold text-slate-900">구분</th>
                    <th className="px-6 py-4 font-bold text-slate-900 text-center">여과사(mm)</th>
                    <th className="px-6 py-4 font-bold text-slate-900 text-center">여과자리(mm)</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {[
                    ["대", "2-5", "15-30"],
                    ["중", "1.8-1.2", "10-15(20)"],
                    ["소", "0.3-0.34", "5-10"],
                  ].map((row, i) => (
                    <tr key={i}>
                      {i === 0 && (
                        <td
                          rowSpan="3"
                          className="px-6 py-4 bg-slate-50/50 font-medium text-slate-400 border-r border-slate-100"
                        >
                          여과재 종류
                        </td>
                      )}
                      <td className="px-6 py-4 font-bold text-slate-900">{row[0]}</td>
                      <td className="px-6 py-4 text-center text-blue-600 font-medium">{row[1]}</td>
                      <td className="px-6 py-4 text-center text-slate-600">{row[2]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="flex flex-col justify-center p-8 bg-blue-600 rounded-2xl text-white premium-shadow">
              <h4 className="text-xl font-bold mb-6 border-b border-white/20 pb-4">엄격한 품질 기준</h4>
              <ul className="space-y-4 text-sm font-light opacity-90">
                <li className="flex justify-between">
                  <span>세경탁도</span> <span>30도 이하</span>
                </li>
                <li className="flex justify-between">
                  <span>강열감량</span> <span>0.7% 이하</span>
                </li>
                <li className="flex justify-between">
                  <span>마모율</span> <span>3% 이하</span>
                </li>
                <li className="flex justify-between">
                  <span>염산가용율</span> <span>3.5% 이하</span>
                </li>
                <li className="flex justify-between">
                  <span>석영질함량</span> <span>90% 이상</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-16 text-center">
            <img
              src={filterInfo4}
              alt="여과기 최종 상세"
              className="w-full max-w-4xl mx-auto rounded-xl md:rounded-3xl premium-shadow border border-white h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Filter;
